import React, { Component } from 'react';
import PropTypes from 'prop-types';

// modules
import * as d3 from 'd3';

const ramp = (canvas, height, width, color) => {
  const context = canvas.getContext('2d');
  canvas.style.imageRendering = '-moz-crisp-edges';
  canvas.style.imageRendering = 'pixelated';
  canvas.style.borderRadius = '4px';
  for (let i = 0; i < width; ++i) {
    // (x, y, width, height)
    context.fillStyle = color(i / (width - 1));
    context.fillRect(i, 0, 1, height);
  }
  return canvas;
};

class ColorCanvas extends Component {
  constructor(props) {
    super(props);
    this._ref = React.createRef();
  }

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    const { ramp: d, height, width } = this.props;
    const canvas = this._ref.current;
    if (canvas && d) {
      ramp(canvas, height, width, (i) => {
        return d(i);
      });
    }
  }
  render() {
    const { width, height } = this.props;
    return <canvas height={height} width={width} ref={this._ref} />;
  }
}

ColorCanvas.propTypes = {
  ramp: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number
};

ColorCanvas.defaultProps = {
  width: 100,
  height: 48,
  ramp: d3.interpolateRainbow
};

export default ColorCanvas;
